import tools from "../../helpers/tools";
import { CATALOG_STORE_TYPES } from "../reducers/catalogStoreReducers";
import { ERROR_TYPES } from "../reducers/errorReducers";
import catalogStoreAdapters from "../../adapters/catalogStoreAdapters";
import { catalogStoreService } from "../../services/catalogStoreService";

export const catalogStoreActions = (state, dispatch, props) => {
  function getMyCatalogStores() {
    dispatch({ type: CATALOG_STORE_TYPES.LOAD_CATALOG_STORE, payload: true });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: true });

    catalogStoreService
      .getAllCatalogStores()
      .then((res) => {
        dispatch({
          type: CATALOG_STORE_TYPES.GET_CATALOG_STORES,
          payload: { data: res.data, meta: { total: res.data.length } },
        });
      })
      .catch((err) => {
        tools.filterError(
          dispatch,
          err.response.data,
          CATALOG_STORE_TYPES.LOAD_CATALOG_STORE
        );
      });
  }
  function getAllCatalogStores() {
    dispatch({ type: CATALOG_STORE_TYPES.LOAD_CATALOG_STORE, payload: true });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: true });

    catalogStoreService
      .getAllCatalogStores()
      .then((res) => {
        dispatch({
          type: CATALOG_STORE_TYPES.GET_CATALOG_STORES,
          payload: { data: res.data, meta: { total: res.data.length } },
        });
      })
      .catch((err) => {
        tools.filterError(
          dispatch,
          err.response.data,
          CATALOG_STORE_TYPES.LOAD_CATALOG_STORE
        );
      });
  }
  function getCatalogStores(search = { search: null }) {
    dispatch({ type: CATALOG_STORE_TYPES.LOAD_CATALOG_STORE, payload: true });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: true });

    search = tools.getSearchString({
      name: search.search,
      page: search.page,
    });

    catalogStoreService
      .getCatalogStores(search)
      .then((res) => {
        dispatch({
          type: CATALOG_STORE_TYPES.GET_CATALOG_STORES,
          payload: res.data,
        });
      })
      .catch((err) => {
        tools.filterError(
          dispatch,
          err.response.data,
          CATALOG_STORE_TYPES.LOAD_CATALOG_STORE
        );
      });
  }
  function getCatalogStore(uuid) {
    dispatch({ type: CATALOG_STORE_TYPES.LOAD_CATALOG_STORE, payload: true });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: true });

    catalogStoreService
      .getCatalogStore(uuid)
      .then((res) => {
        dispatch({
          type: CATALOG_STORE_TYPES.GET_CATALOG_STORE,
          payload: catalogStoreAdapters.transformForBO(res.data),
        });
      })
      .catch((err) => {
        tools.filterError(
          dispatch,
          err.response.data,
          CATALOG_STORE_TYPES.LOAD_CATALOG_STORE
        );
      });
  }
  // LS-637 — un commercial n'a pas forcément le catalogue d'un véhicule dans son
  // périmètre UserGroup (Catalog::scopeVisiblePour), alors qu'il a le droit de voir
  // ce catalogue via une demande de financement qu'il consulte légitimement.
  // Complète le store avec les catalogues manquants, résolus par UUID (route
  // GET /catalogs/{uuid}, déjà ouverte à tous les rôles authentifiés côté API) —
  // n'écrase jamais la liste générale issue de la recherche par UserGroup.
  function chargerCataloguesManquants(catalogUuids) {
    const manquants = [
      ...new Set(
        (catalogUuids || []).filter(
          (uuid) => uuid && !state.catalogStore.items.some((i) => i.uuid === uuid)
        )
      ),
    ];
    if (manquants.length === 0) return;

    Promise.all(
      manquants.map((uuid) =>
        catalogStoreService
          .getCatalogStore(uuid)
          .then((res) => res.data)
          .catch(() => null)
      )
    ).then((catalogues) => {
      const trouves = catalogues.filter(Boolean);
      if (trouves.length > 0) {
        dispatch({
          type: CATALOG_STORE_TYPES.MERGE_CATALOG_STORE_ITEMS,
          payload: trouves,
        });
      }
    });
  }
  function saveCatalogStore(catalogStoreData) {
    if (catalogStoreData.uuid) {
      updateCatalogStore(catalogStoreData);
    } else {
      createCatalogStore(catalogStoreData);
    }
  }
  function createCatalogStore(catalogStoreData) {
    dispatch({ type: CATALOG_STORE_TYPES.LOAD_CATALOG_STORE, payload: true });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: true });

    catalogStoreService
      .createCatalogStore(catalogStoreData)
      .then((res) => {
        dispatch({
          type: CATALOG_STORE_TYPES.GET_CATALOG_STORE,
          payload: catalogStoreAdapters.transformForBO(res.data),
        });
        tools.filterAlert(
          "success",
          catalogStoreData.name + " a été correctement créé."
        );
        getAllCatalogStores();
        props.history.push("/catalogstores/" + res.data.uuid);
      })
      .catch((err) => {
        tools.filterError(
          dispatch,
          err.response.data,
          CATALOG_STORE_TYPES.LOAD_CATALOG_STORE
        );
      });
  }
  function updateCatalogStore(catalogStoreData) {
    dispatch({ type: CATALOG_STORE_TYPES.LOAD_CATALOG_STORE, payload: true });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: true });

    catalogStoreService
      .updateCatalogStore(catalogStoreData)
      .then((res) => {
        dispatch({
          type: CATALOG_STORE_TYPES.GET_CATALOG_STORE,
          payload: catalogStoreAdapters.transformForBO(res.data),
        });
        tools.filterAlert(
          "success",
          catalogStoreData.name + " a été correctement mis à jour."
        );
      })
      .catch((err) => {
        tools.filterError(
          dispatch,
          err.response.data,
          CATALOG_STORE_TYPES.LOAD_CATALOG_STORE
        );
      });
  }

  return {
    saveCatalogStore,
    createCatalogStore,
    updateCatalogStore,
    getCatalogStores,
    getCatalogStore,
    getAllCatalogStores,
    getMyCatalogStores,
    chargerCataloguesManquants,
  };
};
